import React from "react";
import '../../../styles/Tech.css';
import { DiHtml5, DiCss3, DiJavascript1, DiReact, DiResponsive, DiLinux, DiGit, DiGithub } from 'react-icons/di';
import { FaShieldAlt } from 'react-icons/fa';

function Skill({ skillImage, skillName }) {
    const IconComponent = skillImage;
    return (
        <div className="skills">
            <div className="skillDetails">
                <div className="skillName">
                    <h4>{skillName}</h4>
                </div>
                <div className="skillImg">
                    <IconComponent />
                </div>
            </div>
        </div>
    )
}

const Tech = () => {
    return (
        <div className="skillContainer">
            <h2>Tech Stack</h2>
            <div className="techStack">
                <Skill skillImage={DiHtml5} skillName={"HTML"} />
                <Skill skillImage={DiCss3} skillName={"CSS"} />
                <Skill skillImage={DiJavascript1} skillName={"JavaScript"} />
                <Skill skillImage={DiReact} skillName={"React"} />
                <Skill skillImage={DiResponsive} skillName={"Responsiveness"} />
                <Skill skillImage={DiGit} skillName={"Git"} />
                <Skill skillImage={DiGithub} skillName={"GitHub"} />
                <Skill skillImage={DiLinux} skillName={"Linux"} />
                <Skill skillImage={FaShieldAlt} skillName={"Cyber Security"} />
            </div>
        </div>
    )
}

export default Tech;